import { Tool } from "../Tool";
import * as React from "react";
import { useDrag } from "react-dnd";
import { DragableTypes } from "../../constants/DragableTypes";
import { BinTypes } from "../../constants/BinTypes";
import { ToolTypes } from "../../constants/ToolTypes";
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt';
import { Tooltip } from "@mui/material";

export default function AlphaChannelInsertsTool({ handleFinishToolDragging }) {

    const tool = {
        id: ToolTypes.ALPHA_CHANNEL_INSERTS,
        duration: "5",
        type: BinTypes.TOOL,
        toolType: ToolTypes.ALPHA_CHANNEL_INSERTS,
        displayName: "Alpha Channel Inserts"
    }
    const [{ opacity }, dragRef] = useDrag(
        () => ({
            type: DragableTypes.PLAIN_TOOL,
            item: tool,
            collect: (monitor) => ({
                opacity: monitor.isDragging() ? 0.5 : 1
            }),
            end: (item, monitor) => handleFinishToolDragging(monitor.getDropResult(), tool.toolType),
        }),
        []
    )

    return (
        <Tooltip title={ tool.displayName }>
            <Tool
                ref={dragRef}
                variant="filled"
                square
                style={{ opacity, border: "none" }}
            >
                <PictureInPictureAltIcon sx={{ fontSize: 120, color: "#1976d2", width: "100%", height: "100%" }} />
            </Tool>
        </Tooltip>
    )
}